import { motion } from "framer-motion";
import { fadeUp, slideRight, slideLeft } from "../../animations/variants";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { heroButtons, heroHomePage } from "i18n/homePage";
import { useSelector } from "react-redux";
import { PhoneCall } from "lucide-react";
import CTAButton from "Util/CTAButton";

const Hero = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const lang = useSelector((state) => state.language.lang);
  const t = heroHomePage[lang];
  const btn = heroButtons[lang];

  const scrollToSection = (id) => {
    if (location.pathname !== "/") {
      navigate("/" + id);
      return;
    }
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative overflow-hidden mt-[0px] pt-[80px] md:h-[calc(100vh-0px)]">
      {" "}
      <div
        className="absolute inset-0 md:hidden"
        style={{
          backgroundImage: `url("/maria/mp12.png")`,
          backgroundSize: "90% auto",
          backgroundPosition: "300% 100%",
          backgroundRepeat: "no-repeat",
        }}
      />
      <div className="absolute inset-0 bg-white/70 md:hidden" />
      <div className="relative flex flex-col lg:items-center justify-center item-start lg:py-20 lg:px-6 px-0 py-20">
        {" "}
        <div className="max-w-7xl ml-10 lg:mx-auto  grid md:grid-cols-2 gap-12 items-center ">
          <motion.div
            variants={slideLeft}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            className="pt-0"
          >
            {" "}
            <motion.h2
              variants={fadeUp}
              className="text-sm md:text-base uppercase tracking-widest mt-0 lg:mt-3 text-gray-500 mb-6 lg:text-center"
            >
              {t.heading}
            </motion.h2>
            {t.lines.map((item, index) => (
              <motion.div
                key={index}
                variants={fadeUp}
                className="mb-9 lg:text-center text-left"
              >
                <h1
                  className="text-4xl md:text-5xl lg:text-6xl 
      font-extrabold -tracking-[0.2rem] lg:-tracking-[0.5rem] 
      text-reddark uppercase font-[Cromsin]"
                >
                  {item.title}
                </h1>

                <p className="mt-3 text-2xl md:text-4xl text-gray-800">
                  {item.subtitle}
                </p>
              </motion.div>
            ))}{" "}
            <motion.div
              variants={fadeUp}
              className="mt-6 max-w-xl lg:mx-auto text-left lg:text-center"
            >
              <p className="text-gray-600 text-base md:text-lg leading-relaxed">
                {t.description}
              </p>

              <p className="mt-6 text-xl md:text-2xl font-semibold text-reddark">
                {t.cta}
              </p>
            </motion.div>
            <motion.div
              variants={fadeUp}
              className="mt-8 flex-col sm:flex-row gap-6 justify-center md:justify-center md:flex"
            >
              {/* <button
                onClick={() => navigate("/contact")}
                className="px-8 py-3 border border-reddark bg-reddark text-white rounded-xl font-semibold hover:bg-white hover:text-reddark transition"
              >
                {btn.book}
              </button> */}

              <CTAButton
                icon={PhoneCall}
                text={btn.book}
                onClick={() => navigate("/contact")}
              />
            </motion.div>
          </motion.div>

          <motion.div
            variants={slideRight}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            className="hidden md:block max-w-[500px] flex justify-center border border-reddark rounded-xl pt-10 px-10 pb-0"
          >
            <motion.img
              src="/maria/mp12.png"
              alt="Maria Advisory"
              className="w-full h-auto object-contain"
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
